export const CHART_COLOR_PALETTE = [
  '#5AA454',
  '#A10A28',
  '#C7B42C',
  '#AAAAAA',
  '#1f77b4',
  '#ff7f0e',
  '#2ca02c',
  '#d62728',
  '#9467bd',
  '#8c564b',
] as const;

export const CHART_COLOR_FALLBACK = '#ccc';
